import React from "react";
import { Link } from "gatsby";
import resolveLink from "src/utils/resolveLink";

const Button = ({ children, className, target, type, style, blank, onClick }) => {
  return (
    <Link
      className={`cursor-pointer inline-flex justify-center items-center px-[30px] py-[14px] line-crop font-display tracking-normal text-white uppercase transition duration-300 text-[1.3rem] ${
        className ? className : ""
      }`}
      to={blank ? target : resolveLink(target)}
      type={type}
      style={style}
      target={blank ? '_blank' : null}
      onClick={onClick ? onClick : null}
    >
      {children}
      <i className="fas fa-chevron-right cursor-pointer ml-3 text-xs inline"></i>
    </Link>
  );
};

export default Button;
